import { CardProtectionExclusion } from "src/containers/card-protection/domain/exclusion";
import { ReactComponent as BuildingWearIcon } from "src/assets/icons/hogar/icon_desgaste_edificacion.svg";

const exclusions = [
    {
        id: "clonacion-tarjetas",
        title: "Clonación de tarjetas",
        shortTitle: "Clonación de tarjetas",
        icon: <BuildingWearIcon />,
    },
    {
        id: "influencia-estupefacientes",
        title: "Eventos bajo influencia de algún narcótico, droga o alcohol",
        shortTitle:
            "Eventos bajo influencia de algún narcótico, droga o alcohol",
        icon: <BuildingWearIcon />,
    },
    {
        id: "tarjetas-adicionales",
        title: "Tarjetas adicionales donde no figure tu nombre en el plástico",
        shortTitle:
            "Tarjetas adicionales donde no figure tu nombre en el plástico",
        icon: <BuildingWearIcon />,
    },
    {
        id: "uso-extranjero",
        title: "Uso indebido de tus tarjetas fuera del territorio nacional",
        shortTitle:
            "Uso indebido de tus tarjetas fuera del territorio nacional",
        icon: <BuildingWearIcon />,
    },
    {
        id: "emision-banco-externo",
        title: "Tarjetas emitidas por otras entidades distintas al BCP",
        shortTitle: "Tarjetas emitidas por otras entidades distintas al BCP",
        icon: <BuildingWearIcon />,
    },
    {
        id: "otros",
        title: "Otras exclusiones",
        shortTitle: "Otras exclusiones",
        icon: <BuildingWearIcon />,
        content: (
            <>
                <div className="coverage-content__section">
                    <div className="coverage-content__text bullet">
                        Cualquier evento no reconocido de la tarjeta que se
                        produzca antes de la contratación del seguro
                    </div>
                    <div className="coverage-content__text bullet">
                        Pérdidas que el asegurado pueda cobrar y obtener
                        reembolso de otra entidad financiera
                    </div>
                    <div className="coverage-content__text bullet">
                        Uso fraudulento de la Tarjeta de Crédito o Débito o
                        cuenta del asegurado o parientes o civilmente
                        dependientes, trabajadores que sepan códigos y/o claves
                        y co-titulares o quienes tenga tarjetas adicionales
                    </div>
                    <div className="coverage-content__text bullet">
                        Evento de pérdida de dinero por fallas en proceso o
                        software o hardware de la entidad emisora de la tarjeta
                    </div>
                    <div className="coverage-content__text bullet">
                        Actos delictivos por parte del asegurado
                    </div>
                    <div className="coverage-content__text bullet">
                        Tarjetas (crédito y débito) de alguna entidad no
                        regulada por la SBS del Perú, seguros y AFP del Perú
                    </div>
                    <div className="coverage-content__text bullet">
                        Tarjetas de otras entidades financieras diferentes al
                        contratante de la póliza
                    </div>
                    <div className="coverage-content__text bullet">
                        Hurto o extravío de dinero retirado del cajero
                        automático (ATM) y de un cajero corresponsal debídamente
                        autorizado
                    </div>
                    <div className="coverage-content__text bullet">
                        Los intereses, penalidades por retraso en el pago de la
                        tarjeta
                    </div>
                    <div className="coverage-content__text bullet">
                        Cuando se trata de un caso de lavado de activos
                        reportado a la SBS y/o denuncia al Ministerio Público
                        y/o Poder Judicial
                    </div>
                </div>
                <div className="coverage-content__section coverage-content__text info">
                    Las exclusiones se detallan en el certificado del seguro y
                    en las condiciones particulares, así como la cláusula
                    adicional que corresponda
                </div>
            </>
        ),
    },
] as CardProtectionExclusion[];

export default exclusions;
